export default "__VITE_ASSET__CS46jLPI__"